import AxiosClient from "../utils/AxiosClient";

export const fetchLoans = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10,
  lender_user_id = "",
  borrower_user_id = "",
  top = "",
  status_id = ""
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/loans?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=users.first_name,users.last_name,users.phone_number,users.email&lender_user_id=${lender_user_id}&borrower_user_id=${borrower_user_id}${top}&status_id=${status_id}`
    )
  )?.data;
};


export const fetchLenders = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 20,
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/lenders?page=${page}&search=${search}&sortBy=${sortBy}&sortDir=${sortDir}&search_fields=first_name,last_name,phone_number,email&limit=${limit}`
    )
  )?.data;
};



export const fetchCreditLoans = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10,
  lender_user_id = "",
  borrower_user_id = "",
  top = "",
  status_id = ""
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `portal/credit-lines?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=users.first_name,users.last_name,users.phone_number,users.email&lender_user_id=${lender_user_id}&borrower_user_id=${borrower_user_id}${top}&status_id=${status_id}`
    )
  )?.data;
};

export const fetchLoanRequests = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10,
  lender_user_id = "",
  borrower_user_id = ""
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `p2p/lender/loan-requests?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=users.first_name,users.last_name,users.phone_number,users.email&lender_user_id=${lender_user_id}&borrower_user_id=${borrower_user_id}`
    )
  )?.data;
};

export const fetchLoan = async (id = null) => {
  const client = await AxiosClient();
  return (await client.get(`business/loans/${id}`))?.data;
};

export const fetchLoanStats = async () => {
  const client = await AxiosClient();
  return (await client.get(`business/loans/stats`))?.data;
};

export const fetchLoanSchedules = async (id = null) => {
  const client = await AxiosClient();
  return (await client.get(`business/loans/schedules/${id}`))?.data;
};

export const fetchBorrowerDetails = async (id = null) => {
  const client = await AxiosClient();
  return (await client.get(`p2p/borrower/${id}`))?.data;
};

export const createLoan = async ({
  phone_number,
  email,
  duration,
  tenor_period = "days",
  interest_rate,
  loan_amount,
  require_guarantor = true,
  require_card = true,
  due_date,
  interest_method = "fixed",
}) => {
  const client = await AxiosClient();
  return (
    await client.post("business/loans", {
      phone_number,
      email,
      duration,
      tenor_period,
      interest_rate,
      loan_amount,
      require_guarantor,
      require_card,
      due_date,
      interest_method,
    })
  )?.data;
};

export const updateLoan = async ({
  id,
  phone_number,
  duration,
  tenor_period = "days",
  interest_rate,
  loan_amount,
}) => {
  const client = await AxiosClient();
  return (
    await client.patch(`business/loans/${id}`, {
      phone_number,
      duration,
      tenor_period,
      interest_rate,
      loan_amount,
    })
  )?.data;
};


export const assignLoan = async ({
  id,
  lender_user_id,
}) => {
  const client = await AxiosClient();
  return (
    await client.post(`business/loan/${id}/transfer`, {
      lender_user_id,
    })
  )?.data;
};


export const cancelLoan = async (id, reason) => {
  const client = await AxiosClient();
  return (await client.patch(`business/loans/cancel/${id}`, { reason }))?.data;
};

export const acceptLoan = async (id, pin, bear) => {
  const client = await AxiosClient();
  return (await client.put(`p2p/loans/${id}/accept`, { pin, bear }))?.data;
};

export const approveLoan = async (id, pin) => {
  const client = await AxiosClient();
  return (await client.post(`portal/credit-line/${id}/disbursement`, { pin}))?.data;
};

//INSURANCE

export const fetchInsuranceStats = async () => {
  const client = await AxiosClient();
  return (await client.get(`business/insurance/stats`))?.data;
};

export const fetchInsuranceBusinesses = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/insurance?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=description,nickname,status`
    )
  )?.data;
};

export const fetchInsuranceBusiness = async (id = null) => {
  const client = await AxiosClient();
  return (await client.get(`business/insurance/${id}`))?.data;
};

export const fetchCommissions = async (fromdate,todate) => {
  const client = await AxiosClient();
  return await client.get(
    `business/report/insurance/commissions?fromdate=${fromdate}&todate=${todate}`
  );
};
